module.exports = __webpack_public_path__ + "img/logo.db975645.png";